<div class="page-wrap height-100 black">
  <div class="session-form-hold">
    <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
    <mat-card>
      <mat-card-content>
        <!-- Language Switcher -->
        <div class="session-language-select">
          <language-switcher></language-switcher>
        </div>
        <div class="text-center pt-8 pb-16">
          <img width="60px" src="assets/images/logo-lg.png" alt="" class="mb-05">
           <h2>{{ 'Lets get started' | translate}}</h2>
          <p class="text-muted m-0">{{ 'Please, register your company' | translate }}</p>
        </div>
        <form [formGroup]="signupForm"  (ngSubmit)="signup()">
          <div>
            <mat-form-field class="full-width">
              <label>
                <input id="company-name-field" matInput formControlName="name" placeholder="{{ 'Your Company name' | translate }}" style="text-align: right">
              </label>
              <span matSuffix>{{ baseDomain }}</span>
            </mat-form-field>
            <mat-error *ngIf="signupForm.controls['name'].hasError('required') && signupForm.controls['name'].touched"
                       class="form-error-msg-large">{{ 'Company name is required' | translate }}</mat-error>
            <mat-error *ngIf="signupForm.controls['name'].hasError('minlength') && signupForm.controls['name'].touched"
                       class="form-error-msg-large">{{ 'Company name must be at least 5 characters long' | translate}}</mat-error>
            <mat-error *ngIf="signupForm.controls['name'].hasError('pattern') && signupForm.controls['name'].touched"
                       class="form-error-msg-large">{{ 'Company name must contain only lowercase letters or digits' | translate}}</mat-error>
            <mat-error *ngIf="nameErrMsg && !signupForm.controls['name'].dirty"
                       class="form-error-msg-large"> {{ nameErrMsg | translate }}</mat-error>
          </div>

          <div class="pb-1" style="margin-top: 10px">
            <mat-checkbox id="terms-checkbox" formControlName="agreed" class="pb-1" [disableRipple]="true">{{ 'I have read and agree to the' | translate }}
              <a style="color: #069" href="https://teamtrackerhq.com/license">{{ 'terms of service' | translate }}</a>.
            </mat-checkbox>
              <mat-error
                *ngIf="signupForm.controls['agreed'].hasError('required') && signupForm.controls['agreed'].touched"
                class="form-error-msg-large"> {{ 'You must agree to the terms and conditions' | translate }} </mat-error>
          </div>

          <button id="company-sign-up-button" mat-raised-button class="mat-primary full-width mb-1" [disabled]="signupForm.invalid">{{ 'Sign up' | translate }}</button>
          <div class="text-center">
            <a [routerLink]="'/sessions/signin'" class="mat-primary text-center full-width">{{ 'Sign in with registered domain' | translate }}</a>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
